import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import SequenceTemplate from './SequenceTemplate'
import { lang } from '../../assets/lang'

export default class SequenceComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.SEQUENCE)

    this.data.component = SequenceTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
  }

  builder(node) {
    node.lingualName = lingualName.SEQUENCE
    this.setConnection()

    const sequenceInput = new Rete.Input(CONST_SOCKET.SEQUENCE_INPUT, lang.sequence_socket_input_reply, this.socket.sequenceInput, false)
    const sequenceOutput = new Rete.Output(CONST_SOCKET.SEQUENCE_OUTPUT, lang.sequence_socket_output_next, this.socket.sequenceOutput, true)

    return node
      .addInput(sequenceInput)
      .addOutput(sequenceOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    // do nothing
  }

  setConnection() {
    if (this.isSequenceAddonAvailable) {
      this.socket.sequenceInput.combineWith(this.socket.newPostbackOutputSequence)
      this.socket.sequenceInput.combineWith(this.socket.otnSingleOutputSequence)
    }

    this.socket.sequenceOutput.combineWith(this.socket.sequenceSingleInput)
  }
}